import { Link, useLocation } from 'react-router-dom';
import { categories, categorySlugMap } from '@/mocks/categories';

export default function CategoryTabs() {
  const location = useLocation();
  const currentSlug = location.pathname.split('/category/')[1];

  return (
    <div className="flex items-center gap-1 flex-wrap">
      <Link
        to="/"
        className={`px-4 py-2 text-sm rounded-full transition-all whitespace-nowrap ${
          location.pathname === '/'
            ? 'bg-primary-500 text-background-50 font-medium'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 text-sm rounded-full transition-all whitespace-nowrap ${
            currentSlug === cat.slug
              ? 'bg-primary-500 text-background-50 font-medium'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} mr-1.5`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}